import React from "react"
import {Box, Typography} from "@mui/material"
import Grid from '@mui/material/Grid';
import makeStyles from "@material-ui/core/styles/makeStyles";
import OutlinedInput from '@mui/material/OutlinedInput';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import IconButton from "@mui/material/IconButton/IconButton";

const useStyles = makeStyles({
    input: {
        margin: '4px',
    },
    title: {
        fontSize: '14px',
    },
    container: {
        marginTop: '20px',
        marginLeft: '40px',
    },
});

export const Item = ({data, onChangeData, remove}) => {
    const classes = useStyles();

    const onChange = (event, ind) => {
        const name = event.target.name
        let value = event.target.value

        data[ind][name] = value

        onChangeData(data)
    }

    return (
        <Box className={classes.container}>
            <Typography className={classes.title} component="h4">Title of segment details</Typography>
            <Grid container spacing={1}>
                {data.length && data.map((item, ind) => (
                    <Grid key={ind} item xs={12}>
                        <Box>
                            <IconButton onClick={(e) => remove(ind)} aria-label="delete">
                                <RemoveCircleOutlineIcon/>
                            </IconButton>
                            <OutlinedInput
                                style={{width: '220px'}}
                                value={item.name}
                                onChange={(e) => onChange(e, ind)}
                                name='name'
                            />
                        </Box>
                    </Grid>
                ))}
            </Grid>

        </Box>
    )
}